import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, Divider } from 'rebass';
import { Redirect, withRouter } from 'react-router-dom';

import AppContainer from '../AppContainer';
import { FONT_SIZE, COLOR } from '../../Components/Theme';
import { Text, Tabs, Link } from '../../Components/Base';
import { isMed } from '../../Util/Subject';
import * as DateUtils from '../../Util/DateUtils';
import { QueryComponent } from '../../GraphQL';
import { queryExamCardDetail } from '../../GraphQL/query/MockExam.query';

import ExamInfo from './Components/ExamInfo';
import Overview from './Routes/T1Overview';
import ScoreByTopics from './Routes/T2ScoreByTopics';
import SolutionGroups from './Routes/T3SolutionGroups';

class LinkWithHref extends Component {
  static propTypes = {
    href: PropTypes.string,
  };

  handleClick = evt => {
    evt.preventDefault();
    const { history, href } = this.props;
    history.push(href);
  };

  render() {
    const { staticContext, history, location, match, ...restProps } = this.props;
    return <Link {...restProps} onClick={this.handleClick} />;
  }
}

const LinkWithRouter = withRouter(LinkWithHref);

const Toolbar = ({ title }) => (
  <Box mb={[2, 0]}>
    <LinkWithRouter fontSize={[FONT_SIZE.large]} href="/mockexam" is="a">
      การสอบทั้งหมด
    </LinkWithRouter>
    <Text fontSize={[FONT_SIZE.large]} color={COLOR.borderGrey} mx={1} is="span">
      /
    </Text>
    <Text fontSize={[FONT_SIZE.large]} is="span">
      {title}
    </Text>
  </Box>
);

const SUBMENUS = [
  {
    path: 'overview',
    title: '1. ผลคะแนนรวม',
    // href: 'overview',
    exact: true,
    private: true,
    // roles: ['administrator'],
    route: Overview,
  },
  {
    path: `topics`,
    title: '2. คะแนนตามบท',
    // href: 'topics',
    exact: true,
    private: true,
    // roles: ['administrator'],
    // route: ScoreByTopics,
    route: ScoreByTopics,
  },
  {
    path: `solutions`,
    title: '3. เฉลยละเอียด',
    // href: 'answer',
    private: true,
    // hidden: true,
    // roles: ['administrator'],
    route: SolutionGroups,
  },
];

export function getMockExamDate({ examStartDate, examEndDate }, examDateStr) {
  if (examStartDate && examEndDate) return DateUtils.generateDateRange(examStartDate, examEndDate);
  return examDateStr;
}

class MockExamDetails extends Component {
  handleTabsChange = value => {
    const { history, match } = this.props;
    if (history && match) {
      const {
        params: { examCardId },
      } = match;
      const menuPath = SUBMENUS[value].path;
      history.push(match.path.replace(':examCardId', examCardId).replace(':tabName', menuPath));
    }
  };
  render() {
    const { menus, match } = this.props;
    const {
      params: { examCardId, tabName },
      url,
    } = match;

    if (tabName === null || tabName === undefined)
      return <Redirect to={url + '/' + SUBMENUS[0].path} />;

    const foundTabIndex = SUBMENUS.findIndex(menu => menu.path === tabName);
    const initTabIndex = foundTabIndex > -1 ? foundTabIndex : 0;

    return (
      <AppContainer menus={menus}>
        <QueryComponent query={queryExamCardDetail} variables={{ examCardId }}>
          {data => (
            <Box>
              <Toolbar title={data.myMockExamCard.exam.title} />
              <Divider borderColor="borderGrey" style={{ marginBottom: 32 }} />
              <ExamInfo
                subjectName={data.myMockExamCard.exam.title}
                examCardDetail={data.myMockExamCard}
                examId={data.myMockExamCard.examId}
                mockExamDate={getMockExamDate(
                  data.myMockExamCard,
                  data.myMockExamCard.exam.examDate,
                )}
              />
              <Tabs
                hideOnPrint={true}
                items={SUBMENUS.map(m => ({
                  ...m,
                  label: m.title,
                  // href: `#${m.href}`,
                  component: React.createElement(m.route, {
                    subjectName: data.myMockExamCard.exam.title,
                    subjectCode: data.myMockExamCard.exam.subjectCode,
                    scoreVariant: isMed(data.myMockExamCard.exam.subjectCode) ? 'meds' : 'other',
                    examCardId: data.myMockExamCard.id,
                    examId: data.myMockExamCard.examId,
                    relatedExam: data.myMockExamCard.exam.relatedExam,
                  }),
                }))}
                value={initTabIndex}
                onChange={this.handleTabsChange}
              />
            </Box>
          )}
        </QueryComponent>
      </AppContainer>
    );
  }
}

export default MockExamDetails;
